/* tslint:disable */
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataContextService } from "src/app/services/datacontext.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: "app-avatar",
  templateUrl: "./avatar-image.component.html",
  styleUrls: ["./avatar-image.component.less"]
})
export class AvatarComponent implements OnInit {
  @Input() email: string;
  @Input() userInitials: string;

  @Output() imageBroken: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isExternal: EventEmitter<any> = new EventEmitter<any>();
  avatarImage: any;
  isimageBroken = false;

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.email && this.email.length > 0) {
      //this.callDPNUserprofile(this.email);
    } else {
      this.isExternal.emit({ isimageBroken: false, isExternal: true });
    }
  }

  constructor(private _http: HttpClient, private dataContextService: DataContextService) {
  }

  callDPNUserprofile(email: string) {
    this.avatarImage = null;
    const graphApiExpiry = localStorage.getItem("msal.graphApiTokenExpiry");

    let avatarurl: string = "";
    if (email.toLowerCase().endsWith("_test")) {
      email = email.toLowerCase().split("_test")[0];
    }
    avatarurl = "https://graph.microsoft.com/v1.0/users/" + email + "/photo/$value";

    let myHeader = new HttpHeaders();
    myHeader = myHeader.append("Content-Type", "text/plain");
    myHeader = myHeader.append("Content-Transfer-Encoding", "base64");

    const currenttime = Math.floor(new Date().getTime() / 1000);

    if (currenttime >= Number(graphApiExpiry)) {
      //this.getGraphToken().then(() => {
        // myHeader = myHeader.append("Authorization", "Bearer " + localStorage.getItem("msal.graphApiAccessToken"));
        // this._http
        //   .get(avatarurl, {
        //     headers: myHeader,
        //     responseType: "arraybuffer"
        //   })
        //   .subscribe(
        //     (res) => {
        //       this.avatarImage = this.extracturl(res);
        //     },
        //     (err) => {
        //       this.erroDPNUserprofile(err);
        //     }
        //   );
      //});
    } else {
      myHeader = myHeader.append("Authorization", "Bearer " + localStorage.getItem("msal.graphApiAccessToken"));
      this._http
        .get(avatarurl, {
          headers: myHeader,
          responseType: "arraybuffer"
        })
        .subscribe(
          (res) => {
            this.avatarImage = this.extracturl(res);
          },
          (err) => {
            this.erroDPNUserprofile(err);
          }
        );
    }
  }

  erroDPNUserprofile(err: any) {
    this.imageBroken.emit(true);
    this.isExternal.emit({ isimageBroken: true, isExternal: false });
    if ((err.StatusCode = 401)) {
      // this._authTokenService.getGraphToken();
    }
  }

  extracturl(data: any) {
    return "data:image/png;base64," + this.dataContextService.arrayBufferToBase64(data);
  }

  // getGraphToken(): Promise<any> {
  //   const graphApiReq = {
  //     scopes: ["user.read"]
  //   };
  //   return this.msalService.acquireTokenSilent(graphApiReq).toPromise().then((graphToken) => {
  //     localStorage.setItem("msal.graphApiAccessToken", graphToken.accessToken);
  //   })
  //     .catch(_ => {
  //     });
  // }
}
